import {GvfService} from "../../gvf/js/gvf-service";
import {GvfUiService} from "../../gvf/js/gvf-ui-service";
import Swal from "sweetalert2";
class Utils{
    /**
     * Creates an alert based on an endpoint response
     * @param {*} response
     */
    alertEndpointResponse(response){
        if(typeof response == "string"){
            response = {error:true,message:response};
        }

        let isError = true;
        let message = "Error";
        if($.isPlainObject(response)){
            if(response.hasOwnProperty("responseJSON")){ //ajax catched error
                isError = (response.status!=200);
                message = response.statusText;
                response = response.responseJSON;
            }else{
                isError = (response.hasOwnProperty("error") && response.error);
            }
            if(response.hasOwnProperty("message")){
                message = response.message;
            }
        }

        let type = isError?"warning":"success";
        let title = isError?"Error":"";

        if(message.length<300){
            Swal.fire(
                {
                    title: title,
                    text: message,
                    icon : type,
                    confirmButtonColor: "#000000"
                }
            );
        }else{
            const $modal = $("<div class=\"modal\" tabindex=\"-1\"><div class=\"modal-dialog modal-dialog-scrollable\" role=\"document\"><div class=\"modal-content\"><div class=\"modal-body\">"+message.replace(/\n/,"<br />")+"</div></div></div></div>");
            $("body").append($modal);
            $modal.modal("show");
        }
    }
    showLoginModal(){
        this.$loginModal = $("#createLogin").clone();
        GvfService.endpoint(
            "/web/login/login-modal-form",
            {}
        ).then(
            (resp) => {
                this.$loginModal.find(".js-mod-header__create-login-modal-body").empty();
                this.$loginModal.find("#createLoginModalTitle").text(resp.title);
                this.$loginModal.find(".js-mod-header__create-login-modal-body").append(resp.html);
                this.$loginModal.modal('show');
                GvfUiService.init(this.$loginModal);
            }
        ).catch(Utils.alertEndpointResponse);

    }


}

const s_Utils = new Utils();
export {s_Utils as Utils};
